'use client';
import { jsx } from "react/jsx-runtime";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { useInheritDocDirection } from "@tameeni/shared-logic";
import * as React from "react";
import { selectionInputVariants } from "./selection-input.variants.js";
const ToggleGroupContext = React.createContext({
  size: "default",
  isInvalid: false,
  direction: "horizontal"
});
const SelectionInput = React.forwardRef(
  ({
    children,
    className,
    onValueChange,
    size = "default",
    isInvalid = false,
    direction = "horizontal",
    shouldForceSelection = false,
    locale,
    ...props
  }, ref) => {
    const { groupRoot } = selectionInputVariants({
      direction,
      size
    });
    const { direction: docDirection } = useInheritDocDirection({ locale });
    return /* @__PURE__ */ jsx(
      ToggleGroupPrimitive.Root,
      {
        ref,
        className: groupRoot({ className }),
        ...props,
        onValueChange: (value) => {
          if (!value && shouldForceSelection) {
            return;
          }
          onValueChange == null ? void 0 : onValueChange(value);
        },
        dir: props.dir || docDirection,
        children: /* @__PURE__ */ jsx(ToggleGroupContext.Provider, { value: { direction, size, isInvalid }, children })
      }
    );
  }
);
SelectionInput.displayName = ToggleGroupPrimitive.Root.displayName;
const SelectionInputItem = React.forwardRef(({ className, children, ...props }, ref) => {
  const context = React.useContext(ToggleGroupContext);
  const { item } = selectionInputVariants({
    direction: context.direction,
    size: context.size,
    isInvalid: context.isInvalid
  });
  return /* @__PURE__ */ jsx(
    ToggleGroupPrimitive.Item,
    {
      ref,
      className: item({ className }),
      ...props,
      children
    }
  );
});
SelectionInputItem.displayName = ToggleGroupPrimitive.Item.displayName;
export {
  SelectionInput,
  SelectionInputItem
};
